import { NavLink, Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth, KICK_LOGIN_URL } from "@/lib/auth";

export function AdminLayout() {
  const auth = useAuth();
  const location = useLocation();

  if (auth.loading) {
    return (
      <div className="max-w-5xl mx-auto px-4 py-12">
        <p className="font-mono text-sm text-carp-ink/60">Sprawdzam sesję…</p>
      </div>
    );
  }

  if (!auth.user) {
    return (
      <div className="max-w-2xl mx-auto px-4 py-16">
        <div className="brut bg-carp-paper p-8 text-center">
          <h1 className="font-display font-bold text-3xl">Tylko dla zalogowanych</h1>
          <p className="mt-3 text-carp-ink/80">
            Zaloguj się przez Kick. Jeśli twój nick jest na liście adminów —
            wjedziesz do panelu od razu.
          </p>
          <div className="mt-6">
            <a href={KICK_LOGIN_URL} className="btn-primary">
              Zaloguj przez Kick
            </a>
          </div>
        </div>
      </div>
    );
  }

  if (auth.user.role !== "Admin") {
    return (
      <div className="max-w-2xl mx-auto px-4 py-16">
        <div className="brut bg-carp-paper p-8 text-center">
          <h1 className="font-display font-bold text-3xl">Brak uprawnień</h1>
          <p className="mt-3 text-carp-ink/80">
            Twój nick <b>@{auth.user.kickUsername}</b> nie jest na liście adminów.
            Jeśli to pomyłka — admin musi nadać Ci rolę w panelu.
          </p>
          <Navigate to="/" replace state={{ from: location.pathname }} />
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 grid lg:grid-cols-12 gap-6">
      <aside className="lg:col-span-3">
        <div className="brut bg-carp-paper p-4 sticky top-24">
          <p className="font-display font-bold text-xs uppercase tracking-wide text-carp-ink/60 mb-3">
            Panel admina
          </p>
          <nav className="flex flex-col gap-1 text-sm">
            <SideLink to="/admin">Dashboard</SideLink>
            <SideLink to="/admin/sales">Sprzedaże</SideLink>
            <SideLink to="/admin/queue">Kolejka</SideLink>
            <SideLink to="/admin/users">Użytkownicy</SideLink>
            <SideLink to="/admin/overlay">OBS overlay</SideLink>
            <SideLink to="/admin/settings">Ustawienia</SideLink>
            <SideLink to="/admin/graph">Graf widzów</SideLink>
            <SideLink to="/admin/diagnostics">Diagnostyka</SideLink>
          </nav>
        </div>
      </aside>
      <section className="lg:col-span-9">
        <Outlet />
      </section>
    </div>
  );
}

function SideLink({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <NavLink
      to={to}
      end={to === "/admin"}
      className={({ isActive }) =>
        `px-3 py-2 border-l-4 font-display font-semibold transition-colors ${
          isActive
            ? "bg-carp-yellow border-carp-primary text-carp-ink"
            : "border-transparent text-carp-ink/70 hover:bg-carp-yellow/40 hover:text-carp-ink"
        }`
      }
    >
      {children}
    </NavLink>
  );
}
